import { apiRequestEnvelope } from "./client";
import type { AuditLog } from "../types/log";

export type ListLogsParams = {
  cursor?: string | null;
  limit?: number;
  startAt?: string;
  endAt?: string;
};

export type ListLogsResult = {
  items: AuditLog[];
  cursor: string | null;
  nextCursor: string | null;
  limit: number;
  total: number;
};

export async function listLogs(
  params: ListLogsParams,
): Promise<ListLogsResult> {
  const search = new URLSearchParams();
  if (params.cursor) search.set("cursor", params.cursor);
  if (params.limit) search.set("limit", String(params.limit));
  if (params.startAt) search.set("startAt", params.startAt);
  if (params.endAt) search.set("endAt", params.endAt);

  const envelope = await apiRequestEnvelope<{ items: AuditLog[] }>({
    path: `/logs${search.toString() ? `?${search.toString()}` : ""}`,
    method: "GET",
  });

  const pagination = envelope.meta?.pagination;

  return {
    items: envelope.data?.items ?? [],
    cursor: pagination?.cursor ?? null,
    nextCursor: pagination?.nextCursor ?? null,
    limit: pagination?.limit ?? params.limit ?? 20,
    total: pagination?.total ?? 0,
  };
}
